import { ButtonProps } from "fe-shared/src/components";
import { CorrectionMaterial } from "fe-shared-transactions/src/types";

import { InventoryAdjustment } from "../../../types/inventoryAdjustments";

export enum InventoryAdjustmentAction {
  Approve = "Approve",
  Invalidate = "Invalidate",
  SignOf = "SignOf",
}

export type ActionPermissions = {
  [key in InventoryAdjustmentAction]?: boolean;
};

export interface ActionConfig {
  name: InventoryAdjustmentAction;
  isVisible: (
    inventoryAdjustment: InventoryAdjustment,
    permissions: ActionPermissions,
    isCurrentUserAssignee: boolean
  ) => boolean;
  isDisabled?: (inventoryAdjustment: InventoryAdjustment) => boolean;
  hasConfirmationDialog: boolean;
  buttonProps: Partial<ButtonProps>;
  dialogButtonProps?: Partial<ButtonProps>;
}

export interface EditInventoryAdjustmentParams {
  comment: string;
  overallAdjustmentNumber: string;
  additions: CorrectionMaterial[];
  subtractions: CorrectionMaterial[];
}
